import { gql } from '@lcs/shared/api';

export const SaveCallDetailMutation = gql`
   mutation SaveCallDetail($callDetail: CallDetailInput!) {
      callDetail: saveCallDetail(callDetail: $callDetail) {
         callDetailId
         endTime
         callerChannelId
      }
   }
`;
